// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZP26","top":"styles_top__1L0Em","left":"styles_left__2nUrJ","description":"styles_description__1jP1Q"};